var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.467,
    height: 160.357,
    viewBox: "0 0 153.467 160.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    transform: "translate(-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69807",
    "data-name": "Group 69807",
    transform: "translate(11 25.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69806",
    "data-name": "Group 69806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69804",
    "data-name": "Group 69804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89181",
    "data-name": "Path 89181",
    d: "M75.276,127.965a49.8,49.8,0,0,1-37.367-47.28,76.725,76.725,0,0,0,.1,116.795l-.114-6.534A49.8,49.8,0,0,1,75.275,142.68a7.595,7.595,0,0,0,0-14.715Z",
    transform: "translate(-11 -80.685)",
    fill: "#5eff5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89182",
    "data-name": "Path 89182",
    d: "M320.622,80.685a49.8,49.8,0,0,1-37.366,47.28,7.6,7.6,0,0,0,0,14.715,49.8,49.8,0,0,1,37.377,48.266l-.114,6.528a76.719,76.719,0,0,0,.1-116.789Z",
    transform: "translate(-194.064 -80.685)",
    fill: "#5eff5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69805",
    "data-name": "Group 69805",
    transform: "translate(21.297 23.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89183",
    "data-name": "Path 89183",
    d: "M314.087,156.445A49.722,49.722,0,0,1,283.255,180a7.6,7.6,0,0,0,0,14.715,49.753,49.753,0,0,1,33.074,27.983,55.435,55.435,0,0,0-2.242-66.25Z",
    transform: "translate(-215.361 -156.445)",
    fill: "#4ec44b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89184",
    "data-name": "Path 89184",
    d: "M121.978,194.711a7.595,7.595,0,0,0,0-14.715,49.723,49.723,0,0,1-30.832-23.552,55.435,55.435,0,0,0-2.242,66.25A49.754,49.754,0,0,1,121.978,194.711Z",
    transform: "translate(-79 -156.444)",
    fill: "#4ec44b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69813",
    "data-name": "Group 69813",
    transform: "translate(30.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69812",
    "data-name": "Group 69812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69810",
    "data-name": "Group 69810",
    transform: "translate(7 14.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89185",
    "data-name": "Path 89185",
    d: "M158.568,104.961a50.2,50.2,0,0,0,36.683-58.212H96.814A50.2,50.2,0,0,0,133.5,104.961a7.282,7.282,0,0,1,0,14.108,50.164,50.164,0,0,0-37.184,55.1q2.092,1.781,4.309,3.413h90.822q2.217-1.63,4.309-3.413a50.164,50.164,0,0,0-37.184-55.1,7.282,7.282,0,0,1,0-14.108Z",
    transform: "translate(-95.885 -46.749)",
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89186",
    "data-name": "Path 89186",
    d: "M114.568,312.035l.269.313h39.407a3.449,3.449,0,0,0,3.445-3.445V251.511a13.421,13.421,0,0,0-.1-1.652h-.315a13.053,13.053,0,0,1-9.7,14.289,44.354,44.354,0,0,0-33.284,42.987,43.905,43.905,0,0,0,.276,4.9Z",
    transform: "translate(-108.525 -186.245)",
    fill: "#f2fbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69808",
    "data-name": "Group 69808",
    transform: "translate(51.102 65.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89187",
    "data-name": "Path 89187",
    d: "M269.192,267.771a13.047,13.047,0,0,1-9.8-12.636h-.343v55.432a1.338,1.338,0,0,0,.412.973,1.371,1.371,0,0,0,.942.382,1.342,1.342,0,0,0,.613-.148l.735-.374a23.232,23.232,0,0,1,16.489-1.746l23.21,6.16.75-.156h0a43.906,43.906,0,0,0,.276-4.9A44.353,44.353,0,0,0,269.192,267.771Z",
    transform: "translate(-259.046 -255.135)",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89188",
    "data-name": "Path 89188",
    d: "M120.755,77.69H196.59l1.221-.343a44.354,44.354,0,0,0,4.178-30.6H115.357a44.354,44.354,0,0,0,4.178,30.6Z",
    transform: "translate(-108.525 -46.75)",
    fill: "#f2fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89191",
    "data-name": "Path 89191",
    d: "M364.116,435.2a3.278,3.278,0,1,0-6.331-1.68Z",
    transform: "translate(-275.758 -310.618)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89192",
    "data-name": "Path 89192",
    d: "M179.517,233.3a23.576,23.576,0,0,0-16.732,1.771l-.734.373a1.012,1.012,0,0,1-1.47-.9v-55.43a13.047,13.047,0,0,1,9.8-12.636,44.263,44.263,0,0,0,28.027-22.033H120.158a44.263,44.263,0,0,0,28.027,22.033,13.047,13.047,0,0,1,9.8,12.636V236.5a3.132,3.132,0,0,1-3.132,3.132H115.179a43.939,43.939,0,0,0,.86,5.047h86.489a43.939,43.939,0,0,0,.86-5.047Z",
    transform: "translate(-109.136 -113.845)",
    fill: "#ffbd86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89193",
    "data-name": "Path 89193",
    d: "M179.517,233.3a23.576,23.576,0,0,0-16.732,1.771l-.734.373a1.012,1.012,0,0,1-1.47-.9v-55.43a13.042,13.042,0,0,1,5.651-10.745,13.033,13.033,0,0,0-4.152-1.892,44.283,44.283,0,0,1-28.038-22.033H120.158a44.263,44.263,0,0,0,28.027,22.033,13.047,13.047,0,0,1,9.8,12.636V236.5a3.132,3.132,0,0,1-3.132,3.132H115.179a43.939,43.939,0,0,0,.86,5.047h86.489a43.939,43.939,0,0,0,.86-5.047Z",
    transform: "translate(-109.136 -113.845)",
    fill: "#f6a96c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3026",
    "data-name": "Ellipse 3026",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(69.994 103.659)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3027",
    "data-name": "Ellipse 3027",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(30.437 115.669)",
    fill: "#ffbd86"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3028",
    "data-name": "Ellipse 3028",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(57.349 109.104)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3029",
    "data-name": "Ellipse 3029",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(66.607 34.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69809",
    "data-name": "Group 69809",
    transform: "translate(18.02 41.594)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3030",
    "data-name": "Ellipse 3030",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(35.557)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3031",
    "data-name": "Ellipse 3031",
    cx: 3.278,
    cy: 3.278,
    r: 3.278,
    transform: "translate(0 68.901)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89194",
    "data-name": "Path 89194",
    d: "M273.042,457.988a3.277,3.277,0,0,0-6.525,0Z",
    transform: "translate(-231.096 -368.746)",
    fill: "#fed2a4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89195",
    "data-name": "Path 89195",
    d: "M341.953,455.113a3.278,3.278,0,1,0-6.245,0Z",
    transform: "translate(-260.489 -324.277)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69811",
    "data-name": "Group 69811",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89196",
    "data-name": "Path 89196",
    d: "M184.2,14.985H77.16a3.626,3.626,0,0,1-3.626-3.626V3.626A3.626,3.626,0,0,1,77.16,0H184.2a3.626,3.626,0,0,1,3.626,3.626v7.732A3.626,3.626,0,0,1,184.2,14.985Z",
    transform: "translate(-73.534 0)",
    fill: "#00a7ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_89198",
    "data-name": "Path 89198",
    d: "M109.507,463.4a76.755,76.755,0,0,0,91.763,0Z",
    transform: "translate(-98.24 -318.261)",
    fill: "#00a7ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPending);
export default __webpack_public_path__ + "static/media/status-pending.292ae5d80d29778e3954e7536dbc6c8b.svg";
export { ForwardRef as ReactComponent };